const inputCls = "w-full bg-[#0A0B0E] border border-[#282C37] rounded-lg px-3 py-2 text-amber-50 text-sm";
function Field({ label, children }) { return <label className="block text-sm text-stone-300">{label}<span className="block mt-1">{children}</span></label>; }

export const inheritedPolicy = { mode: "INHERIT", deposit_type: "FIXED", deposit_value: 10 };

export default function PaymentPolicyField({ value = inheritedPolicy, onChange, allowInherit = true }) {
  const policy = { ...inheritedPolicy, ...value };
  return <div className="space-y-3">
    <Field label="Política de pagamento"><select value={policy.mode} onChange={(e) => onChange({ ...policy, mode: e.target.value })} className={inputCls}>
      {allowInherit && <option value="INHERIT">Herdar padrão</option>}
      <option value="NONE">Sem pagamento antecipado</option>
      <option value="DEPOSIT">Sinal parcial</option>
      <option value="FULL_PREPAY">Pagamento integral antecipado</option>
    </select></Field>
    {policy.mode === "DEPOSIT" && <div className="grid grid-cols-2 gap-3">
      <Field label="Tipo de sinal"><select value={policy.deposit_type} onChange={(e) => onChange({ ...policy, deposit_type: e.target.value })} className={inputCls}><option value="FIXED">Valor fixo (R$)</option><option value="PERCENT">Percentual (%)</option></select></Field>
      <Field label="Valor"><input type="number" min="0.01" max={policy.deposit_type === "PERCENT" ? 100 : 10000} step="0.01" value={policy.deposit_value} onChange={(e) => onChange({ ...policy, deposit_value: Number(e.target.value) })} className={inputCls} /></Field>
    </div>}
    {policy.mode === "FULL_PREPAY" && <p className="text-sm text-stone-400">Pagamento integral necessário para confirmar este agendamento.</p>}
  </div>;
}
